import PropTypes from 'prop-types'
import medalExposicionOro from './img/exposicionOro.png'
import medalExposicionPlata from './img/exposicionPlata.png'
import medalExposicionPlatino from './img/exposicionPlatino.png'
import './ExposicionTipo.css'

const PLAN_PLATINO = 1
const PLAN_ORO = 2
const PLAN_PLATA = 3

const ExposicionTipo = (props) => {
  const { exposicion, name, checked, value, onChange, disabled, precioCalculado } = props

  const obtenerClases = () => {
    const arrClases = ['btn btn-exposicionTipo']
    if (checked) {
      arrClases.push('clicked')
    }
    if (disabled) {
      arrClases.push('disabled')
    }
    return arrClases.join(' ')
  }

  const obtenerImagen = () => {
    switch (exposicion.idPublicacionExposicion) {
      case PLAN_PLATINO:
        return <img src={medalExposicionPlatino} className="medal" alt={exposicion.nombre} />
      case PLAN_ORO:
        return <img src={medalExposicionOro} className="medal" alt={exposicion.nombre} />
      case PLAN_PLATA:
        return <img src={medalExposicionPlata} className="medal" alt={exposicion.nombre} />
      default:
        return null
    }
  }

  return (
    <div className="btn-group btn-group-toggle exposicionTipo-borde">
      <label className={obtenerClases()}>
        <input
          type="radio"
          name={name}
          checked={checked}
          value={value}
          onChange={onChange}
          disabled={disabled}
          aria-disabled={disabled}
        />
        <div className="text-center">{obtenerImagen()}</div>
        <h3 className="exposicionTipo-titulo">Exposición {exposicion.nombre}</h3>
        <div className="text-center">
          {precioCalculado > 0 && (
            <span className="size">
              <i className="fa fa-usd" aria-hidden="true" />
              {precioCalculado}
            </span>
          )}
          <div>
            <span>{exposicion.precio}% del precio unitario</span>
          </div>
        </div>
      </label>
    </div>
  )
}

ExposicionTipo.propTypes = {
  exposicion: PropTypes.shape({
    idPublicacionExposicion: PropTypes.number,
    nombre: PropTypes.string,
    descripcion: PropTypes.string,
    precio: PropTypes.number
  }).isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  precioCalculado: PropTypes.number
}

export default ExposicionTipo
